const WORLD_SCALE = 50;

/**
 * Server x is distance along the climb. Three.js uses y as up, so that
 * progress maps to +Z (forward) with a small lateral X wobble.
 */
export function toThreeCourse(course) {
  let lateral = 0;
  return course.platforms.map((platform, index) => {
    if (index > 0) {
      const step = (hashNumber(`${course.seed}:${platform.id}`) % 3) - 1;
      lateral = Math.max(-2, Math.min(2, lateral + step));
    }
    const isPickup = platform.type === "pickup";
    return {
      ...platform,
      x: lateral * 0.9,
      y: platform.y / WORLD_SCALE,
      z: platform.x / WORLD_SCALE,
      width: Math.max(3.8, platform.width / WORLD_SCALE),
      depth: platform.type === "shelter" || platform.type === "finish" ? 5.5 : 4.2,
      type: isPickup ? "normal" : platform.type,
      hasPickup: isPickup,
      moveAxis: platform.movement?.axis === "x" ? "z" : "x",
      moveRange: (platform.movement?.distance ?? 80) / WORLD_SCALE,
      moveSpeed: platform.movement ? (Math.PI * 2 * 1000) / platform.movement.periodMs : undefined,
      phase: (platform.movement?.phase ?? 0) * Math.PI * 2,
    };
  });
}

export function toServerSnapshot(snapshot, velocity, sequence) {
  return {
    x: snapshot.z * WORLD_SCALE,
    y: snapshot.y * WORLD_SCALE,
    vx: velocity.z * WORLD_SCALE,
    vy: velocity.y * WORLD_SCALE,
    seq: sequence,
    clientTime: performance.now(),
    facing: Math.cos(snapshot.yaw) >= 0 ? 1 : -1,
    animation: Math.hypot(velocity.x, velocity.z) > 0.3 ? "run" : "idle",
  };
}

export function fromServerPosition(snapshot, course) {
  const nearest = nearestPlatformByHeight(snapshot.y / WORLD_SCALE, course);
  return {
    x: nearest?.x ?? 0,
    y: snapshot.y / WORLD_SCALE,
    z: snapshot.x / WORLD_SCALE,
    yaw: snapshot.facing < 0 ? Math.PI : 0,
  };
}

function nearestPlatformByHeight(y, course) {
  let nearest = null;
  let distance = Infinity;
  for (const platform of course) {
    const nextDistance = Math.abs(platform.y - y);
    if (nextDistance < distance) {
      nearest = platform;
      distance = nextDistance;
    }
  }
  return nearest;
}

function hashNumber(value) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
